var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('live-timer',{attrs:{"start":_vm.start,"end":_vm.end,"stopped":_vm.stopped}})}
var staticRenderFns = []

export { render, staticRenderFns }